import { bindRequestLogic } from './utils'
import Types from '../actionTypes/configurationPersComn'
import { configurationPersComnAPI } from '../api'

const getConfigurationPersComns = bindRequestLogic({
  clientFunc: configurationPersComnAPI.getConfigurationPersComns,
  type: Types.GET_CONFIGURATION_PERS_COMNS_REQUEST,
  successType: Types.GET_CONFIGURATION_PERS_COMNS_SUCCESS,
  failType: Types.GET_CONFIGURATION_PERS_COMNS_FAILED,
  isQueryParam: true
})

export default [getConfigurationPersComns]
